import React from "react";

const CommonButton = ({onClick,buttonTitle,className,type,disabled, style}) => {
  return (
    <button type={type} style={style} className={className} onClick={onClick} disabled={disabled}>
      {buttonTitle}
    </button>
  );
};

export default CommonButton;
